import { ActionType } from "../action-types"
import { Actions } from "../actions"

interface submitPrimarySaleState {
    loading: boolean
    payload?: any
}

export const defaultSubmitPrimarySaleState: submitPrimarySaleState = {
    loading: false
}

const submitPrimarySaleReducer = (state: submitPrimarySaleState = defaultSubmitPrimarySaleState, action: Actions): submitPrimarySaleState => {
    switch (action.type) {
        case ActionType.SUBMIT_PRIMARY_SALE_REQUEST:
            return {
                loading: true
            }
        case ActionType.SUBMIT_PRIMARY_SALE_FAILURE:
            return {
                loading: false,
                payload: action.error
            }
        case ActionType.SUBMIT_PRIMARY_SALE_SUCCESS:
            return {
                loading: false,
                payload: action.payload
            }
        case ActionType.CLEAR_ALL:
            return {
                loading: false
            }
        default:
            return state
    }
}

export default submitPrimarySaleReducer